module.exports = __webpack_public_path__ + "img/icon-invisible.4bea412f.svg";